import React, { useEffect, useState } from 'react';

import { WEBVIEW } from '@constants/serviceConstants';
import { sendNativeMessageAPI } from '@lib/native';
import { sendAiMessage } from '@lib/ai';
import { mdctFeed } from '@api/axiosAPI';
import { AI_FEED_GRP_CD_MDCT } from '@constants/codeConstants';

const AiChatTemplate = () => {
  const [mdctFeedSrno, setMdctFeedSrno] = useState(null); // 투약피드일련번호

  /**
   * 투약 조언 프롬프트 템플릿 조회
   */
  const { refetch: fetchMdctPrptTmpt } = mdctFeed.getMdctFeedPrptTmpt(
    ['getMdctPrptTmpt'],
    {
      enabled: false,
      staleTime: 0,
      cacheTime: 0,
      onSuccess: (res) => {
        onSuccessMdctPrptTmpt(res);
      },
    },
    { mdctFeedSrno }
  );

  /**
   * 투약피드내역 수정
   */
  const putMdctFeedDtl = mdctFeed.putMdctFeedDtl({
    onSuccess: () => {
      sendNativeMessageAPI(WEBVIEW.SEND_CODE.AI_CHAT, { resultCode: 200 });
      setMdctFeedSrno(null);
    },
  });

  /**
   * AI 에이전트 조언 요청
   * @param {*} args
   */
  const getAiAdvice = (args) => {
    const { aiFeedGrpCd, mdctFeedSrno } = args; // 건강검진, 내가먹는약, ...

    switch (aiFeedGrpCd) {
      case AI_FEED_GRP_CD_MDCT:
        setMdctFeedSrno(mdctFeedSrno);
        break;
    }
  };

  /**
   * 투약 AI 에이전트 조언 요청
   * @param {*} dataList
   */
  const onSuccessMdctPrptTmpt = async (dataList) => {
    try {
      const returnData = _.cloneDeep(dataList);

      let index = 0;
      for await (let data of dataList) {
        const result = await sendAiMessage(data.prptTmpt);

        returnData[index].mdctFeedCtt = result.content;
        index++;
      }

      putMdctFeedDtl.mutate(returnData);
    } catch (err) {
      sendNativeMessageAPI(WEBVIEW.SEND_CODE.AI_CHAT, { resultCode: 500, resultData: err });
    }
  };

  useEffect(() => {
    if (!_.isNull(mdctFeedSrno)) {
      fetchMdctPrptTmpt();
    }
  }, [mdctFeedSrno]);

  window.getAiAdvice = getAiAdvice;

  return <div>webview area</div>;
};

export default AiChatTemplate;
